import React from "react"
import { Link } from "gatsby-link"
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react"
import { ChevronRightIcon } from "@chakra-ui/icons"
import { componentStyles } from "@mallardbay/lib-react-components"

import {
    Text,
    TextActive,
} from "~components/shared/todo-lib-react-components/text"

import Box from "./box"

interface Props {
    readonly items: BreadcrumItemType[]
}

export default function Breadcrumbs({ items }: Props) {
    const styles = useStyles()

    return (
        <Breadcrumb sx={styles.root} separator={<ChevronRightIcon />}>
            {items.map((item) => (
                <BreadcrumbItem key={item.label}>
                    <BreadcrumbItemContent {...item} />
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    )
}

function BreadcrumbItemContent({
    to,
    label,
    isActive,
    isDisabled,
    onClick,
}: BreadcrumItemType) {
    const isClickable = Boolean(to) || Boolean(onClick)
    const isLink = isClickable && !isActive && !isDisabled

    if (!isLink) return <BreadcrumItemLabel label={label} isActive={isActive} />

    return (
        <BreadcrumbLink as={Link} to={to} isCurrentPage={isActive}>
            <BreadcrumItemLabel
                label={label}
                isActive={isActive}
                onClick={onClick}
            />
        </BreadcrumbLink>
    )
}

function BreadcrumItemLabel({
    label,
    isActive,
    onClick,
}: Omit<BreadcrumItemType, "to">) {
    const styles = useStyles()

    const TextComponent = isActive ? TextActive : Text

    return (
        <Box onClick={onClick}>
            <TextComponent style={styles.text}>{label}</TextComponent>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            ol: { flexWrap: "wrap", rowGap: 2 },
        },
        text: { whiteSpace: "nowrap" },
    })
}

export interface BreadcrumItemType {
    readonly to?: string
    readonly label: string
    readonly isActive?: boolean
    readonly isDisabled?: boolean
    readonly onClick?: () => void
}
